import * as React from 'react';
import { classes, useSlug } from '@bloomberg/media-ui-core';

import { type SubmenuItem, THEMES } from '../types';
import { useTranslateMessage } from '../utils/translate-messages';

import styles from './SubmenuDesktop.module.css';

export type SubmenuDesktopProps = {
  menuItemId: string;
  submenuItem: SubmenuItem;
  theme?: THEMES;
  trackingFunction: (submenuText: string, dropdownListItemText: string) => void;
};

export const SubmenuDesktop = React.forwardRef<
  HTMLDivElement,
  SubmenuDesktopProps
>(function SubmenuDesktopComponent(props: SubmenuDesktopProps, ref) {
  const {
    menuItemId,
    submenuItem,
    theme = THEMES.DARK,
    trackingFunction,
  } = props;

  const { id, text, dropdownListItems } = submenuItem;
  const translateMessage = useTranslateMessage();

  const componentName = useSlug('submenu-desktop');

  if (!dropdownListItems?.length) {
    return null;
  }

  const cx = classes([
    styles.submenuDesktopContainer,
    {
      [styles.dark]: theme === THEMES.DARK,
    },
  ]);

  return (
    <div
      className={cx}
      key={id}
      ref={ref}
      aria-label={translateMessage({
        id: 'media-ui-nav_arialabel_subMenuDesktop',
        defaultMessage: 'submenu-desktop',
      })}
      data-component={componentName}
    >
      {text && (
        <div
          className={styles.submenuText}
          data-menuid={menuItemId}
          data-submenuid={id}
        >
          {text}
        </div>
      )}
      {dropdownListItems.map((item, idx) => {
        const className = classes([
          styles.link,
          { [styles.linkWithLabel]: item.label },
        ]);

        return (
          <a
            className={className}
            data-menuid={menuItemId}
            data-submenuid={menuItemId}
            href={item.url}
            key={`${id}:${item.id}-${idx}`}
            onClick={() => trackingFunction(text, item.text)}
          >
            {item.text}
            {item.label && <span className={styles.label}>{item.label}</span>}
          </a>
        );
      })}
    </div>
  );
});
